'use strict';

/* global $ */

import { Ajax } from 'utils/ajax';

function Calculator(options) {

    let opt = $.extend({
        parent: options.selector+'__parent',
        nested: options.selector+'__nested',
    }, options);


    function initBlock() {

        console.log('[ Calculator/Init ]');

        $(opt.parent).find('select').on('change', function() {
            console.log('[ Calculator/Change ]');

            let params = $(this).data();
            params.value = $(this).val();

            Ajax.get('get_nested', params).then((data) => {
                if (data.ok) {
                    $(data.items).each(function() {
                        let item = this;
                        console.log(item);
                        let $nested = $(opt.nested).find('select').filter('[data-field_id="'+item.object_id+'"]');
                        $nested.parent(opt.nested).addClass('is-hidden');
                        console.log($nested);
                        $nested.find('option').remove();
                        $(item.values).each(function() {
                            let value = this;
                            let newOption = new Option(value.object_name, value.object_id, false, false);
                            $nested.append(newOption);
                        });
                        $nested.trigger('change');
                        if (item.values.length) {
                            $nested.parent(opt.nested).removeClass('is-hidden');
                        }
                    });
                } else {
                    console.error('Can\'t get field');
                }
            }).catch(function(error) {
                throw new Error(error);
            });

        });
    }

    initBlock();
}

export {
    Calculator
};
